/* ===========================================================
   FollicGen — storefront interactions (Shopify, no dependencies)
   -----------------------------------------------------------
   Drives: reveal-on-scroll, sticky header / mobile ATC / floating
   reviews pill, FAQ accordion, before/after slider, reviews
   "show more", the selling-plan buy box, and a real AJAX cart
   drawer (cart/add.js, cart.js, cart/change.js).

   All content is rendered server-side from section settings &
   blocks; this file only wires behaviour. Safe to defer.
   =========================================================== */
(function () {
  "use strict";

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";

  /* money formatting — uses the shop's format string when present */
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && window.fgMoneyFormat) {
      try { return window.Shopify.formatMoney(cents, window.fgMoneyFormat); } catch (e) {}
    }
    var amount = (cents / 100);
    return "$" + amount.toLocaleString(undefined, { minimumFractionDigits: amount % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  /* ===================================================== *
   * Reveal on scroll
   * ===================================================== */
  function initReveal() {
    var els = $$(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) { el.classList.add("in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ===================================================== *
   * Sticky header / mobile ATC / floating reviews
   * ===================================================== */
  function initStickies() {
    var header = $("#fg-header");
    var mobileAtc = $("#fg-mobile-atc");
    var floatReviews = $("#fg-float-reviews");
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (header) header.classList.toggle("scrolled", y > 40);
      if (mobileAtc) mobileAtc.classList.toggle("show", y > 620);
      if (floatReviews) floatReviews.classList.toggle("show", y > 900);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    if (floatReviews) {
      floatReviews.addEventListener("click", function () {
        var r = $("#reviews");
        if (r) window.scrollTo({ top: r.getBoundingClientRect().top + window.scrollY - 60, behavior: "smooth" });
      });
    }
  }

  /* ===================================================== *
   * Smooth-scroll CTAs -> buy box
   * ===================================================== */
  function initScrollCtas() {
    $$("[data-fg-scroll-to]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        var sel = btn.getAttribute("data-fg-scroll-to");
        var target = sel && $(sel);
        if (target) {
          e.preventDefault();
          window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 70, behavior: "smooth" });
        }
      });
    });
  }

  /* ===================================================== *
   * FAQ accordion (single-open)
   * ===================================================== */
  function initFaq() {
    $$("[data-fg-faq]").forEach(function (list) {
      var items = $$(".faq-item", list);
      function setOpen(item, open) {
        var a = $(".faq-a", item);
        item.classList.toggle("open", open);
        var btn = $(".faq-q", item);
        if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
        if (a) a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
      }
      items.forEach(function (item, i) {
        var a = $(".faq-a", item);
        if (item.classList.contains("open") && a) a.style.maxHeight = a.scrollHeight + "px";
        var q = $(".faq-q", item);
        if (!q) return;
        q.addEventListener("click", function () {
          var willOpen = !item.classList.contains("open");
          items.forEach(function (o) { if (o !== item) setOpen(o, false); });
          setOpen(item, willOpen);
        });
      });
      window.addEventListener("resize", function () {
        items.forEach(function (item) {
          if (item.classList.contains("open")) {
            var a = $(".faq-a", item);
            if (a) a.style.maxHeight = a.scrollHeight + "px";
          }
        });
      });
    });
  }

  /* ===================================================== *
   * Reviews "show more"
   * ===================================================== */
  function initReviews() {
    $$("[data-fg-reviews]").forEach(function (section) {
      var grid = $(".review-grid", section);
      var btn = $("[data-fg-reviews-more]", section);
      if (!grid) return;
      var step = parseInt(section.getAttribute("data-reveal-count"), 10) || 6;
      var cards = $$(".review-card", grid);
      var shown = step;
      function apply() {
        cards.forEach(function (c, i) { c.style.display = i < shown ? "" : "none"; });
        if (btn) btn.style.display = shown >= cards.length ? "none" : "";
      }
      apply();
      if (btn) btn.addEventListener("click", function () { shown += step; apply(); });
    });
  }

  /* ===================================================== *
   * Before / After slider
   * ===================================================== */
  function initBeforeAfter() {
    $$(".ba").forEach(function (ba) {
      var dragging = false;
      function setPos(clientX) {
        var r = ba.getBoundingClientRect();
        var pct = ((clientX - r.left) / r.width) * 100;
        pct = Math.max(2, Math.min(98, pct));
        ba.style.setProperty("--ba-pos", pct + "%");
      }
      ba.style.setProperty("--ba-pos", "50%");
      function start(e) { dragging = true; setPos(e.touches ? e.touches[0].clientX : e.clientX); }
      function move(e) { if (dragging) setPos(e.touches ? e.touches[0].clientX : e.clientX); }
      function end() { dragging = false; }
      ba.addEventListener("mousedown", start);
      ba.addEventListener("touchstart", start, { passive: true });
      window.addEventListener("mousemove", move);
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("mouseup", end);
      window.addEventListener("touchend", end);

      var section = ba.closest("[data-fg-ba]") || document;
      $$(".ba-thumb", section).forEach(function (t) {
        t.addEventListener("click", function () {
          $$(".ba-thumb", section).forEach(function (x) { x.classList.remove("is-active"); });
          t.classList.add("is-active");
          var before = t.getAttribute("data-before");
          var after = t.getAttribute("data-after");
          var beforeImg = $(".ba__before img", ba);
          var afterImg = $(".ba__after img", ba);
          if (before && beforeImg) beforeImg.src = before;
          if (after && afterImg) afterImg.src = after;
          ba.style.setProperty("--ba-pos", "50%");
        });
      });
    });
  }

  /* ===================================================== *
   * Buy box (selling plans) + pricing
   * ===================================================== */
  var BuyBox = {
    root: null, mode: "sub", base: 0,
    init: function () {
      this.root = $("#fg-buybox");
      if (!this.root) return;
      this.base = parseFloat(this.root.getAttribute("data-base") || "0");
      var self = this;

      $$(".pt-opt", this.root).forEach(function (opt) {
        opt.addEventListener("click", function () {
          $$(".pt-opt", self.root).forEach(function (x) { x.classList.remove("is-active"); });
          opt.classList.add("is-active");
          self.mode = opt.getAttribute("data-mode");
          self.recalc();
        });
      });
      $$(".bundle", this.root).forEach(function (b) {
        b.addEventListener("click", function (e) {
          if (e.target.closest(".bundle__plan")) return; /* let plan radios work */
          $$(".bundle", self.root).forEach(function (x) {
            x.classList.remove("is-active");
            var r = x.querySelector(".bundle__radio-input"); if (r) r.checked = false;
          });
          b.classList.add("is-active");
          var radio = b.querySelector(".bundle__radio-input"); if (radio) radio.checked = true;
          self.recalc();
        });
      });

      var form = this.root.querySelector("form") || this.root.closest("form");
      if (form) form.addEventListener("submit", function (e) { e.preventDefault(); self.addToCart(); });

      this.recalc();
    },
    selected: function () { return $(".bundle.is-active", this.root) || $(".bundle", this.root); },
    selectedPlanId: function (bundle) {
      if (this.mode !== "sub") return "";
      var checked = bundle && bundle.querySelector(".bundle__plan-opt input:checked");
      if (checked) return checked.value;
      return (bundle && bundle.getAttribute("data-selling-plan-id")) || "";
    },
    recalc: function () {
      var b = this.selected();
      if (!b) return;
      /* keep the product form's hidden id in sync with the chosen plan, so even a
         native (non-AJAX) submit posts the correct variant instead of the default */
      var idInput = this.root.querySelector(".fg-form__id");
      var selVid = b.getAttribute("data-variant-id");
      if (idInput && selVid) idInput.value = selVid;
      var months = parseInt(b.getAttribute("data-months"), 10) || 1;
      var perMonth = parseFloat((this.mode === "sub" ? b.getAttribute("data-sub") : b.getAttribute("data-once"))) || 0;
      var total = perMonth * months;
      var save = (this.base - perMonth) * months;
      var self = this;

      $$(".bundle", this.root).forEach(function (bn) {
        var pm = parseFloat((self.mode === "sub" ? bn.getAttribute("data-sub") : bn.getAttribute("data-once"))) || 0;
        var pmEl = bn.querySelector("[data-pm]");
        if (pmEl) pmEl.innerHTML = money(pm) + "<span>/mes</span>";
        var wasEl = bn.querySelector("[data-was]");
        if (wasEl) wasEl.textContent = money(self.base);
      });

      var amt = $("[data-total-amt]", this.root); if (amt) amt.textContent = money(total);
      var lbl = $("[data-total-lbl]", this.root);
      if (lbl) lbl.textContent = (this.mode === "sub" ? this.root.getAttribute("data-lbl-sub") : this.root.getAttribute("data-lbl-once")).replace("{months}", months);
      var saveEl = $("[data-save-lbl]", this.root);
      if (saveEl) {
        if (save > 0) { saveEl.style.display = ""; saveEl.textContent = (this.root.getAttribute("data-lbl-save") || "Ahorras {amount}").replace("{amount}", money(save)); }
        else { saveEl.style.display = "none"; }
      }

      /* per-month price chips elsewhere on the page */
      $$("[data-price-month]").forEach(function (el) { el.textContent = money(perMonth) + (el.getAttribute("data-suffix") || "/mes"); });
      var offerNow = $("[data-offer-now]"); if (offerNow) offerNow.textContent = money(perMonth);

      Cart.syncSummary(this.mode, months, total);
    },
    addToCart: function () {
      var b = this.selected();
      if (!b) return;
      var variantId = b.getAttribute("data-variant-id") || (this.root.getAttribute("data-default-variant") || "");
      if (!variantId) { Cart.openDrawer(); return; }
      var planId = this.selectedPlanId(b);
      var cta = $(".buybox__cta", this.root);
      var err = $(".buybox__error", this.root);
      if (err) err.classList.remove("show");
      if (cta) { cta.setAttribute("aria-busy", "true"); }
      var item = { id: variantId, quantity: 1 };
      if (planId) item.selling_plan = planId;
      Cart.add([item]).then(function () {
        if (cta) cta.removeAttribute("aria-busy");
        Cart.openDrawer();
      }).catch(function (msg) {
        if (cta) cta.removeAttribute("aria-busy");
        if (err) { err.textContent = msg || "No se pudo añadir al carrito."; err.classList.add("show"); }
      });
    }
  };
  /* legacy alias used inside recalc */
  function money(n) { return "$" + Math.round(n).toLocaleString(); }

  /* ===================================================== *
   * Cart drawer (real AJAX cart)
   * ===================================================== */
  var Cart = {
    el: null, scrim: null,
    init: function () {
      this.el = $("#fg-cart");
      this.scrim = $("#fg-scrim");
      var self = this;
      $$("#fg-cart-close").forEach(function (b) { b.addEventListener("click", function () { self.closeDrawer(); }); });
      if (this.scrim) this.scrim.addEventListener("click", function () { self.closeDrawer(); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") self.closeDrawer(); });

      /* upsell add buttons */
      $$("[data-fg-upsell]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var id = btn.getAttribute("data-variant-id");
          if (!id) return;
          btn.disabled = true;
          self.add([{ id: id, quantity: 1 }]).then(function () {
            btn.textContent = btn.getAttribute("data-added-label") || "Añadido ✓";
            btn.classList.add("added");
            btn.disabled = false;
          }).catch(function () { btn.disabled = false; });
        });
      });

      /* checkout */
      var checkout = $("[data-fg-checkout]", this.el);
      if (checkout) checkout.addEventListener("click", function () { window.location.href = routes + "checkout"; });

      /* delegate line removal */
      if (this.el) {
        this.el.addEventListener("click", function (e) {
          var x = e.target.closest("[data-fg-remove]");
          if (x) { e.preventDefault(); self.changeLine(x.getAttribute("data-line"), 0); }
        });
      }
      this.refresh();
    },
    _post: function (url, data) {
      return fetch(routes + url, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(data)
      }).then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j && (j.description || j.message)); }); });
    },
    add: function (items) {
      var self = this;
      return this._post("cart/add.js", { items: items }).then(function () { return self.refresh(); });
    },
    changeLine: function (line, quantity) {
      var self = this;
      return this._post("cart/change.js", { line: parseInt(line, 10), quantity: quantity }).then(function (cart) { self.render(cart); return cart; });
    },
    refresh: function () {
      var self = this;
      return fetch(routes + "cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; })
        .catch(function () {});
    },
    syncSummary: function (mode, months, total) {
      /* keep the static "your treatment" summary line in sync before any add */
      var plan = $("[data-cart-plan]");
      if (plan) {
        var tpl = plan.getAttribute("data-tpl") || "Plan {months} meses · {mode}";
        var modeLbl = mode === "sub" ? (plan.getAttribute("data-mode-sub") || "Suscríbete y ahorra") : (plan.getAttribute("data-mode-once") || "Compra única");
        plan.textContent = tpl.replace("{months}", months).replace("{mode}", modeLbl);
      }
    },
    render: function (cart) {
      if (!this.el || !cart) return;
      var body = $(".cart__body", this.el);
      var countEls = $$("[data-cart-count]");
      countEls.forEach(function (el) { el.textContent = cart.item_count; });

      /* update only the line list; keep the gift + upsell blocks intact */
      var lineWrap = $("[data-fg-cart-lines]", this.el);
      if (lineWrap) {
        if (!cart.items || !cart.items.length) {
          lineWrap.innerHTML = '<div class="cart__empty">' + (lineWrap.getAttribute("data-empty") || "Tu carrito está vacío.") + "</div>";
        } else {
          lineWrap.innerHTML = cart.items.map(function (it, i) {
            var sub = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : (it.variant_title || "");
            var img = it.image ? '<div class="ph has-img"><img src="' + it.image + '" alt="" width="70" height="84" loading="lazy"></div>' : '<div class="ph"></div>';
            return '<div class="cart-item">' + img +
              '<div class="ci-t"><b>' + it.product_title + "</b><span>" + sub + "</span></div>" +
              '<div class="ci-p">' + formatMoney(it.final_line_price) + "</div>" +
              '<button class="ci-x" data-fg-remove data-line="' + (i + 1) + '" aria-label="Quitar"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
              "</div>";
          }).join("");
        }
      }
      var totalEl = $("[data-cart-total]", this.el);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    },
    openDrawer: function () {
      if (!this.el) return;
      this.el.classList.add("show");
      if (this.scrim) this.scrim.classList.add("show");
      document.body.style.overflow = "hidden";
      document.body.classList.add("fg-cart-open");
    },
    closeDrawer: function () {
      if (!this.el) return;
      this.el.classList.remove("show");
      if (this.scrim) this.scrim.classList.remove("show");
      document.body.style.overflow = "";
      document.body.classList.remove("fg-cart-open");
    }
  };

  /* ===================================================== *
   * Boot
   * ===================================================== */
  function boot() {
    if (window.__FOLLICGEN_BOOTED__) return; /* load-once guard (asset may be referenced by several sections) */
    window.__FOLLICGEN_BOOTED__ = true;
    initReveal();
    initStickies();
    initScrollCtas();
    initFaq();
    initReviews();
    initBeforeAfter();
    Cart.init();
    BuyBox.init();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
